import { Category } from "@/types";

export const filterRFCategories = (categories: Category[]): Category[] => {
	return categories.filter((cat) => cat.slug !== "outside-the-box" && cat.slug !== "other");
};
